import axios from 'axios';
import authHeader from './auth.header';
const API_URL = 'https://contabilidadelider.com/api/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getInfoUsuario() {
    return axios.get(API_URL + "usuario", { headers: authHeader() });
  }
  listarUsuario() {
    return axios.get(API_URL + "usuario" + "/listarUsuario", { headers: authHeader() });
  }
  editUsuario(payload) {
    return axios.post(
      API_URL + "usuario" + "/editUsuario", {
      id: payload.id,
      nome: payload.nome,
      genero: payload.genero,
      pis: payload.pis,
      dataEntrada: payload.dataEntrada,
      dataSaida: payload.dataSaida,
      jornadaSemanal: payload.jornadaSemanal,
      setores: payload.setores,
      email: payload.email,
      senha: payload.senha,
      ativo: payload.ativo
    },
      { headers: authHeader() }
    );
  }
  removerUsuario(payload) {
    return axios.post(
      API_URL + "usuario" + "/removerUsuario", {
      id: payload.id,
    },
      { headers: authHeader() }
    );
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
}

export default new UserService();